"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinVisibleHeight = exports.defaultGetOptionValue = exports.defaultGetOptionLabel = exports.defaultGetOptionGroup = exports.dataCyRoleSelectAllCheckbox = exports.dataCyRoleFilterInput = exports.dataCyActionSelectAll = exports.dataCyActionDeselect = exports.dataCyActionAddOption = exports.dataCy = exports.TYPE_SUBTITLE = exports.SEARCH_INPUT_DEBOUNCE_TIMEOUT = exports.ROW_HEIGHT = exports.NO_RECORDS_PLACEHOLDER_DEFAULT = exports.NO_DATA_PLACEHOLDER_DEFAULT = exports.MIN_OPTION_COUNT_FOR_FILTERING = exports.LOADING_PLACEHOLDER_DEFAULT = exports.GROUP_HEIGHT = exports.EMPTY_SELECTED_OPTIONS = void 0;
var dataCy = exports.dataCy = 'SelectDropdownMenu';
var dataCyRoleFilterInput = exports.dataCyRoleFilterInput = 'selectDropdownMenuFilterInput';
var dataCyRoleSelectAllCheckbox = exports.dataCyRoleSelectAllCheckbox = 'selectDropdownMenuSelectAllCheckbox';
var dataCyActionAddOption = exports.dataCyActionAddOption = 'addOption';
var dataCyActionSelectAll = exports.dataCyActionSelectAll = 'selectAll';
var dataCyActionDeselect = exports.dataCyActionDeselect = 'deselect';
var MIN_OPTION_COUNT_FOR_FILTERING = exports.MIN_OPTION_COUNT_FOR_FILTERING = 10;
var EMPTY_SELECTED_OPTIONS = exports.EMPTY_SELECTED_OPTIONS = [];
var NO_DATA_PLACEHOLDER_DEFAULT = exports.NO_DATA_PLACEHOLDER_DEFAULT = 'No matches found';
var NO_RECORDS_PLACEHOLDER_DEFAULT = exports.NO_RECORDS_PLACEHOLDER_DEFAULT = 'No records';
var LOADING_PLACEHOLDER_DEFAULT = exports.LOADING_PLACEHOLDER_DEFAULT = 'Loading';
var ROW_HEIGHT = exports.ROW_HEIGHT = 42;
var GROUP_HEIGHT = exports.GROUP_HEIGHT = 20;
var SEARCH_INPUT_DEBOUNCE_TIMEOUT = exports.SEARCH_INPUT_DEBOUNCE_TIMEOUT = 300;
var getMinVisibleHeight = exports.getMinVisibleHeight = function getMinVisibleHeight(count) {
  return Math.min((count || 1) * ROW_HEIGHT, ROW_HEIGHT * 6);
};
var TYPE_SUBTITLE = exports.TYPE_SUBTITLE = 'subtitle';
var defaultGetOptionValue = exports.defaultGetOptionValue = function defaultGetOptionValue(option) {
  return option === null || option === void 0 ? void 0 : option.id;
};
var defaultGetOptionLabel = exports.defaultGetOptionLabel = function defaultGetOptionLabel(option) {
  return option === null || option === void 0 ? void 0 : option.name;
};
var defaultGetOptionGroup = exports.defaultGetOptionGroup = function defaultGetOptionGroup(option, groupBy) {
  if (typeof groupBy === 'function') {
    return option[groupBy(option)] || '';
  }
  if (typeof groupBy === 'string') {
    return option[groupBy] || '';
  }
  return '';
};